import InFeedAdsenseComponent from './InFeedAdsenseComponent.vue'

const InFeedAdsense = {
  install: (app, options) => {
    app.component('InFeedAdsense', InFeedAdsenseComponent)
  },
}

export default InFeedAdsense
